// path.model.ts

// Firestore collection/document paths for reuse across the app
export const FIRESTORE_PATHS = {
  RESEARCH_REPORTS: 'research-reports',
  USERS: 'users',
  REPORT_TEMPLATES: 'report-templates',
  RULE_SETS: 'rule-sets',
  // Add other collection/document paths here as needed
};
